import { Main } from './components/containers';
import { PackingProvider } from './services/PackingContext';

export const Packing = () => {
  return (
    <PackingProvider>
      <Main />
    </PackingProvider>
  );
};
